import script from "./ClientsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsDetail.vue?vue&type=script&setup=true&lang=js"

import "./ClientsDetail.vue?vue&type=style&index=0&id=facd2f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-facd2f72"]])

export default __exports__